import React, { Fragment, useContext } from "react";

import { Grid, Typography, Stack } from "@mui/material";

import LoadingPage from "../../react_utils/LoadingPage";
import InfoTooltip from "../../react_utils/InfoTooltip";
import ChargingHistoryTable from "./wallbox/ChargingHistoryTable";
import ExcelExport from "../../react_utils/ExcelExport";
import DatePicker from "../../react_utils/DatePicker";
import TablePagination from "../../react_utils/table/TablePagination";
import useChargingHistory from "../../shared/hooks/wallbox/useChargingHistory";
import CustomerLocationClient from "../../shared/api/CustomerLocationClient";
import {
  chargingHistoryExport,
  chargingHistoryHelp,
  chargingHistoryTitle,
} from "../../shared/constants/charginghistory";
import { AuthContext } from "../../shared/contexts/AuthContext";
import { MessagingContext } from "../MessagingContext";

export default function ChargingHistory() {
  const { apiClient } = useContext(AuthContext);
  const { showMessage } = useContext(MessagingContext);

  const locationClient = new CustomerLocationClient(apiClient);

  const { chargingHistory, excelExport, pagination } = useChargingHistory(
    locationClient,
    null,
    showMessage,
  );

  if (chargingHistory === null) return <LoadingPage />;

  return (
    <Fragment>
      <div className="text-center">
        <Typography sx={{ marginY: "10px" }}>
          {chargingHistoryTitle}{" "}
          <InfoTooltip>{chargingHistoryHelp}</InfoTooltip>
        </Typography>
      </div>
      <Grid container justify="center" sx={{ marginBottom: "50px" }}>
        <Grid
          xs={12}
          sm={12}
          md={12}
          item
          justifyContent="center"
          alignItems="center"
        >
          <ChargingHistoryTable chargingHistory={chargingHistory} />
        </Grid>
        <Grid xs={12} sm={12} md={12} item paddingTop={"10px"}>
          <TablePagination
            nPages={pagination.nPages}
            page={pagination.page}
            setPage={pagination.setPage}
          />
        </Grid>
      </Grid>
      <Typography sx={{ marginBottom: "20px" }}>
        {chargingHistoryExport}
      </Typography>
      <Stack direction="row" spacing={2}>
        <DatePicker
          date={excelExport.datePicker.date}
          setDate={excelExport.datePicker.setDate}
          views={["month", "year"]}
        />
        <ExcelExport
          exporter={excelExport.getData}
          fileName={excelExport.filename}
          disabled={excelExport.disabled}
        />
      </Stack>
    </Fragment>
  );
}

ChargingHistory.propTypes = {};
